import 'url-search-params-polyfill'
import { component } from 'picoapp'
import { zelektor, loopify, debounce, renderProductCard } from '@/lib/utility-functions.js'
import { fetchByUrl } from '@/lib/collection-filter.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { input, output, viewMoreBtn } = zelektor(node)
    const { pageSize } = node.dataset
    const searchPage = {
        currentPage: 0,
    }

    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    const inputQuery = debounce(() => {
        const { value } = input

        viewMoreBtn.classList.remove('is-visible')
        output.innerHTML = `<li class="search-page__item--empty">${window.theme.strings.search.searcing}</li>`

        processQuery(value)
    }, 500)

    async function processQuery(query) {
        searchPage.currentPage = 0

        const params = encodeURIComponent(query)
        window.history.replaceState('', {}, `${window.location.pathname}${params.length ? '?query=' : ''}${params}`)

        if (!query.length) searchPage.pages = undefined

        const productHandles = await fetchClerkProducts(query)
        const products = productHandles.length ? await fetchProducts(productHandles.slice(0, 250)) : []

        processResults(query, products)
    }

    function fetchClerkProducts(query) {
        return fetch(
            `https://api.clerk.io/v2/search/search?key=${window.theme.clerkKey}&query=${query}&limit=1000&attributes=["name","handle"]&visitor=auto&labels=["Search Page"]`
        )
            .then((r) => r.json())
            .then((data) => {
                const products = data.product_data || []
                return products.map((p) => p.handle)
            })
    }

    function fetchProducts(handles) {
        const store = Shopify.shop.replace('.myshopify.com', '')
        const products = []
        let productsFetched = 0

        return new Promise((resolve) => {
            handles.forEach(async (handle) => {
                const p = await fetch(`/products/${handle}.json`)
                    .then((r) => r.json())
                    .then((p) => p.product)
                p.url = `/products/${handle}`
                products.push(p)
                productsFetched++

                if (productsFetched >= handles.length) {
                    resolve(products)
                }
            })
        })

        // return fetchByUrl(`https://middleman.app.grafikrdev.dk/${store}/products?limit=250&ids=${IDs.join(',')}`)
    }

    function processResults(query, products) {
        output.innerHTML = ''
        let gender_search = getCurrentGender() // returns gender_men || gender_women || empty string
        if (gender_search) {
            products = products.filter(function (p) {
                return p.tags.includes(gender_search)
            })
        }
        searchPage.pages = paginateProducts(products)
        renderProducts()
    }

    function paginateProducts(products) {
        const paginatedProducts = []

        do {
            paginatedProducts.push(products.splice(0, pageSize))
        } while (products.length)

        return paginatedProducts.map((p) => p.reverse())
    }

    function renderProducts() {
        const { pages, currentPage } = searchPage

        loopify(pages[currentPage]).forEach((product) => {
            renderProductCard({
                product,
                parentEl: output,
                wrapper: {
                    elementType: 'li',
                    className: 'search-page__item grid__item',
                },
                middleMan: true,
            })
        })
        Clerk('click', '*[data-clerk-product-id]')

        if (!pages[currentPage].length)
            output.innerHTML = `<li class="search-page__item--empty">${window.theme.strings.search.noResults}</li>`

        currentPage + 1 === pages.length
            ? viewMoreBtn.classList.remove('is-visible')
            : viewMoreBtn.classList.add('is-visible')
    }

    function viewMore() {
        searchPage.currentPage++
        renderProducts()
    }

    function getCurrentGender() {
        const header = document.querySelector('#shopify-section-header header')
        if (header.classList.value.indexOf('gender--women') >= 0) return 'gender_women'
        if (header.classList.value.indexOf('gender--men') >= 0) return 'gender_men'
        return ''
    }

    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    input.addEventListener('input', inputQuery)

    init()
    function init() {
        const params = new URLSearchParams(location.search)
        const key = [...params.keys()].find((k) => k === 'query')
        const query = key ? params.get(key) : ''

        input.value = query
        const e = new Event('input')
        input.dispatchEvent(e)
    }

    viewMoreBtn.addEventListener('click', viewMore)
})
